<template>
  <div class="main-container">
   <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />

    <tl-header type="h1">
      <div class="main-header margintop-30">Assign FBP Components</div>
    </tl-header>
    <div class="filters marginbot-20">
      <tl-select
        label="Assign FBP Components to"
        name="components_assignee"
        :options="assigneeList"
        @change="getSelectedItem($event)"
      ></tl-select>
    </div>
    <data-table
      v-if="selectedAssignee == 'salaryGrade'"
      :columns="gradesColumnData"
      :tableData="salaryGradesData"
      :showinrow="true"
      :showedit="true"
      :showdelete="false"
      :showhistory="false"
      :with-form="false"
      @editStart="initEditStart($event)"
      @delete="deleteItem"
      @update="updateItem"
      @selected="selected"
      @deselected="deselected"
      :checkbox="true"
    >
      <template v-slot:rowcontent="slotprops">
        <p v-if="slotprops.value.column.key== 'components'">
          <span
            v-for="(item, index) in slotprops.value.record[slotprops.value.column.key]"
            :key="index"
          >{{(index+1) &lt; (slotprops.value.record[slotprops.value.column.key].length) ? item.component+"," :item.component}}</span>
        </p>
      </template>
    </data-table>
    <data-table
      v-if="selectedAssignee == 'salaryBand'"
      :columns="bandsColumnData"
      :tableData="salaryBandsData"
      :showinrow="true"
      :showedit="showedit"
      :showdelete="false"
      :showhistory="false"
      :checkbox="true"
      :with-form="false"
      @editStart="initEditStart"
      @delete="deleteItem"
      @update="updateItem"
      @selected="selected"
      @deselected="deselected"
    >
      <template v-slot:rowcontent="slotprops">
        <p v-if="slotprops.value.column.key== 'components'">
          <span
            v-for="(item, index) in slotprops.value.record[slotprops.value.column.key]"
            :key="index"
          >{{(index+1) &lt; (slotprops.value.record[slotprops.value.column.key].length) ? item.component+"," :item.component}}</span>
        </p>
      </template>
    </data-table>
    <div class="modal custom-modal" v-if="showModal">
      <div class="modal-content modal-sm">
        <div class="modal-header">
          <h3>Assign FBP Components</h3>
        </div>
        <div class="modal-body">
          <div class="text-secondary" v-if="selectedTableItem.length">
            <span
              v-for="(item, index) in selectedTableItem"
              :key="index"
            >{{(index+1) &lt; (selectedTableItem.length) ? item.name+"," :item.name}}</span>
          </div>
          <div class="text-secondary" v-if="!selectedTableItem.length">{{editedItem}}</div>
          <br />
          <div class="singleColumnGrid">
            <div v-for="(item, index) in assignedComponents" :key="index">
              <tl-checkbox
                :label="item.component"
                :id="item+index"
                :value="item.id"
                @change="getCheckedItem($event,item.id)"
              />
            </div>
            <div>
              <span class="label">Effective Date</span>
              <date-picker
                class="custom-width"
                @datevalue="(val)=>effectiveDate=val"
                :value="effectiveDate"
                name="effectiveDate"
              />
            </div>
          </div>
          <br />
          <div class="singleColumnGrid">
            <btn-grp slot="end" class="btnGrpClass btn-center">
              <btn text="Cancel" type="secondary" class v-on:click="backToFBPPage"></btn>
              <btn text="Assign" type="primary" class v-on:click="assignComponents"></btn>
            </btn-grp>
          </div>
        </div>
      </div>
    </div>
    <pop-up-message
      v-if="showConfirmationModal"
      message="FBP Components Assigneed"
      btnText="Back to FBP Components"
      @back="backToFBPPage"
    ></pop-up-message>
    <bottom-action-container class="placeEnd">
      <template slot="end">
        <btn-grp slot="end" class="btnGrpClass">
          <btn text="Cancel" type="secondary" class v-on:click="cancel"></btn>
          <btn text="Assign FBP Components" type="primary" class v-on:click="assignFbp"></btn>
        </btn-grp>
      </template>
    </bottom-action-container>
    <!-- <btn-grp slot="end" class="btnGrpClass">
      <btn text="Cancel" type="secondary" class v-on:click="cancel"></btn>
      <btn text="Assign FBP Components" type="primary" class v-on:click="assignFbp"></btn>
    </btn-grp>-->
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      breadcrumbList:[
              {
                name: "Payroll",
                url: `/dashboard/${this.$route.params.entity_index}/payroll`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
              },
              {
                name: "Assign FBP Components",
                url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/assign_fbp_components`
              }
        ],
      assigneeList: ["Salary Grades", "Salary Bands"],
      headcheckbox: true,
      showModal: false,
      showConfirmationModal: false,
      selectedAssignee: "",
      assignedComponents: [],
      selectedTableItem: [],
      editedItem: "",
      editedItemId: [],
      effectiveDate: "",
      selectedComponents: [],
      gradesColumnData: [
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Assigned FBP Components",
          key: "components"
        }
      ],
      bandsColumnData: [
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Criteria",
          key: "criteria"
        },
        {
          label: "Assigned FBP Components",
          key: "components"
        }
      ],
      salaryGradesData: [
        {
          id: "G101",
          name: "Grade 1",
          components: [
            { id: "101", component: "Component 1" },
            { id: "102", component: "Component 2" },
            { id: "103", component: "Component 3" },
            { id: "104", component: "Component 4" }
          ]
        },
        {
          id: "G102",
          name: "Grade 2",
          components: [
            { id: "101", component: "Component 1" },
            { id: "102", component: "Component 2" },
            { id: "103", component: "Component 3" }
          ]
        },
        {
          id: "G103",
          name: "Grade 3",
          components: [
            { id: "101", component: "Component 1" },
            { id: "102", component: "Component 2" }
          ]
        },
        {
          id: "G104",
          name: "Grade 4",
          components: [{ id: "101", component: "Component 1" }]
        }
      ],
      salaryBandsData: [
        {
          id: "B101",
          name: "Band A",
          criteria: "Salary 0-3 lacs",
          components: [
            { id: "101", component: "Component 1" },
            { id: "102", component: "Component 2" },
            { id: "103", component: "Component 3" },
            { id: "104", component: "Component 4" }
          ]
        },
        {
          id: "B102",
          name: "Band B",
          criteria: "Salary Grade L1, L2",
          components: [
            { id: "101", component: "Component 1" },
            { id: "102", component: "Component 2" },
            { id: "104", component: "Component 4" }
          ]
        }
      ]
    };
  },
  // mounted(){
  //   this.fetchAssignedComponent();
  // },
  methods: {
    ...mapActions({
      fetch_assigned_components: "dashboard/payroll/utilities/get_fbp/fetchAll",
      assign_component: "dashboard/payroll/utilities/assignfbpcomponents/create"
    }),
    async fetchAssignedComponent() {
      try {
        await this.fetch_assigned_components();
      } catch (error) {
        //console.log(error);
      }
    },
    async assignFbpComponents(payload) {
      try {
        await this.assign_component(payload);
      } catch (error) {
        //console.log(error);
      }
    },
    getSelectedItem(e) {
      if (e == "Salary Grades") {
        this.selectedAssignee = "salaryGrade";
      } else {
        this.selectedAssignee = "salaryBand";
      }
      this.fetchAssignedComponent();
    },
    routeToMainStep() {},
    routeToSubStep() {},
    assignFbp() {
      this.showModal = true;
      this.assignedComponents = [
        { id: "101", component: "Component 1" },
        { id: "102", component: "Component 2" },
        { id: "103", component: "Component 3" },
        { id: "104", component: "Component 4" }
      ];
    },
    getCheckedItem(e, id) {
      if (e) {
        this.selectedComponents.push(id);
      } else {
        let index = this.selectedComponents.indexOf(id);
        if (index > -1) {
          this.selectedComponents.splice(index, 1);
        }
      }
      //console.log(this.selectedComponents);
    },
    initEditStart(e) {
      this.assignedComponents = e.components;
      this.editedItem = e.name;
      this.editedItemId = [e.id];
      //console.log(e);
      this.showModal = true;
    },
    deleteItem() {
      //console.log();
    },
    selected(e) {
      this.selectedTableItem = e;
      //console.log(this.selectedTableItem);
    },
    deselected(e) {
      this.selectedTableItem = e;
      //console.log(this.selectedTableItem);
    },
    updateItem() {},
    backToFBPPage() {
      this.showConfirmationModal = false;
      this.showModal = false;
      this.selectedTableItem = [];
      this.editedItemId = [];
    },
    assignComponents() {
      this.showConfirmationModal = true;
      this.showModal = false;
      let ids = [];
      this.selectedTableItem.forEach(element => {
        ids.push(element.id);
      });
      let body = {
        id: this.editedItemId.length > 0 ? this.editedItemId : ids,
        type: this.selectedAssignee,
        fbpId: this.selectedComponents
      };
      //console.log(body);
      this.assignFbpComponents(body);
      this.selectedTableItem = [];
      this.editedItemId = [];
    },
    cancel() {}
  }
};
</script>
<style lang="scss" scoped>
.filters {
  display: grid;
  grid-gap: 10px;
  grid-template: auto / repeat(4, minmax(180px, 1fr));
}
.bottom-line {
  border-bottom: 1px solid #34c0be;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 5%;
}
.label {
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 10px;
  color: #6e6e6e;
}
.btn-center {
  margin: auto;
}
</style>
